import React from 'react'
import SuccessMessageUI from '../../../../widgets/form/SuccessMessageUI'
import ErrorMessageUI from '../../../../widgets/form/ErrorMessageUI'
import InputDateUI from '../../../../widgets/form/InputDateUI'
import InputTextUI from '../../../../widgets/form/InputTextUI'
import ButtonUI from '../../../../widgets/action/ButtonUI'
import './MoveToCsModal.css' // reuse same modal overlay styles

const AddDsraUpdateCsModalUI = ({
  context,
  addMode,
  onCancelClick,
  //
  title,
  onTitleChange,
  dueDate,
  onDueDateChange,
  //
  submitted,
  successMsg,
  errorList,
  onSubmitClick
}) => {
  if (!addMode) return null

  return (
    <div className='move-to-cs-modal-overlay'>
      <div className='move-to-cs-modal-container'>

        <div className='move-to-cs-modal-header'>
          <h3>Add DSRA Release Condition</h3>
          <button className='move-to-cs-modal-close' onClick={onCancelClick}>×</button>
        </div>

        <div className='move-to-cs-modal-body'>

          <div className='g_m_bottom_100'>
            <InputTextUI
              context={context}
              name='title'
              label='Condition Title'
              required={true}
              value={title}
              onChange={onTitleChange}
              placeholder='e.g. Commissioning certificate received'
              help='DSRA will be released once all DSRA release conditions are complied'
            />
          </div>

          <div className='g_m_bottom_100'>
            <InputDateUI
              context={context}
              name='dueDate'
              label='Due Date'
              required={false}
              selectedDateISO={dueDate}
              onChange={onDueDateChange}
              help='Leave blank if no due date applies'
            />
          </div>

          <SuccessMessageUI show={successMsg} message={successMsg} />
          <ErrorMessageUI errorList={errorList} />
        </div>

        <div className='move-to-cs-modal-footer'>
          <ButtonUI
            label='Cancel'
            onClick={onCancelClick}
            className='g_m_right_50'
            disabled={submitted}
          />
          <ButtonUI
            label='Add DSRA Update CS'
            onClick={onSubmitClick}
            busy={submitted}
            primary={true}
            disabled={!title || typeof title !== 'string' || !title.trim() || submitted}
          />
        </div>

      </div>
    </div>
  )
}

export default AddDsraUpdateCsModalUI